import AddLocation from './AddLocation';
import './addLocation.scss'

export default AddLocation;